import { TYPES } from "./user.type";

const initState = {
  user: null,
  all: null,
  users: null,
};

const userReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.GET_USER_INFO_SUCCESS:
      return {
        ...state,
        user: payload,
      };
    case TYPES.SELECT_ALL_USER_SUCCESS:
      return {
        ...state,
        all: payload,
      };
    case TYPES.SELECT_USERS_SUCCESS:
      return {
        ...state,
        users: payload,
      };
    default:
      return state;
  }
};

export default userReducer;
